import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from '@/components/ui/resizable';
import { ActionBar, DetailToolbar, DocumentEntry, SearchDialog } from './components';
import { ErpDataTableV2, ErpInputTableV2 } from '@/components/custom/erp';
import { usePhanBoThuTienPage } from './context';

export default function PhanBoThuTienChoCacHoaDonPage() {
  const page = usePhanBoThuTienPage();

  return (
    <div className='flex h-screen w-full flex-col overflow-hidden'>
      {page.searchDialog.open ? (
        <SearchDialog
          open={page.searchDialog.open}
          onClose={page.searchDialog.onClose}
          onSearch={page.searchDialog.onSubmit}
        />
      ) : null}

      {page.documentEntry.value ? (
        <DocumentEntry document={page.documentEntry.value} onClose={page.documentEntry.onClose} />
      ) : null}

      <div className={`flex h-full flex-col ${page.searchDialog.open || page.documentEntry.value ? 'hidden' : ''}`}>
        <ActionBar onSearch={page.actions.handleSearch} className='border-b border-gray-200' />

        <ResizablePanelGroup direction='vertical' className='flex-1 overflow-hidden'>
          <ResizablePanel defaultSize={50} minSize={20}>
            <div data-perf-id='phan-bo-thu-tien-cac-hoa-don-master-table' className='h-full overflow-hidden'>
              <ErpDataTableV2
                tables={page.table.tables}
                selectedRowId={page.selection.selectedReceipt?.uuid}
                onRowClick={page.table.onRowClick}
                loading={page.table.displayIsLoading}
                totalItems={page.table.totalItems}
                currentPage={page.table.currentPage}
                onPageChange={page.table.onPageChange}
                onSearchChange={page.table.onSearchChange}
              />
            </div>
          </ResizablePanel>

          <ResizableHandle withHandle className='bg-slate-200/80 hover:bg-slate-300' />

          <ResizablePanel defaultSize={50} minSize={20}>
            <div className='flex h-full flex-col overflow-hidden'>
              <div className='flex-none border-b px-4 py-2'>
                <h2 className='text-[15px] font-semibold text-gray-800'>Chi tiết hóa đơn</h2>
                <p className='text-xs text-gray-600'>{page.allocationTable.summary}</p>
              </div>
              <div
                data-perf-id='phan-bo-thu-tien-cac-hoa-don-bottom-detail-table'
                className='min-h-0 flex-1 overflow-hidden'
              >
                <ErpInputTableV2
                  rows={page.detailTable.rows}
                  columns={page.allocationTable.columns}
                  height='100%'
                  showIndexColumn
                  hideEmptyState={false}
                  loading={page.allocationTable.isLoading}
                  actionLoading={page.allocationTable.isLoading}
                  getRowId={row => row.uuid}
                  toolbar={
                    <DetailToolbar
                      hasReceipt={Boolean(page.selection.selectedReceipt)}
                      loading={page.allocationTable.isLoading}
                      onRefresh={page.allocationTable.refresh}
                    />
                  }
                />
              </div>
            </div>
          </ResizablePanel>
        </ResizablePanelGroup>
      </div>
    </div>
  );
}
